import { Table } from "../../../features/Table";
import { type K2Portfolio, porfolios_columns } from "./columns";
import { type FilterK2PortfoliosSchema, FilterK2Portfolios } from "./filter";

const client = "k2";
const table_name = "k2_portfolios";

export const K2PortfoliosTable = () => {
  return (
    <Table<K2Portfolio, FilterK2PortfoliosSchema>
      label="Portfolios"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterK2Portfolios />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
